import { render, staticRenderFns } from "./SmartLesson.vue?vue&type=template&id=0da462ec"
import script from "./SmartLesson.vue?vue&type=script&lang=js"
export * from "./SmartLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports